import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { resetPassword } from "../apiCalls/user";
import { toast } from "react-toastify";


const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();

  const { isFetching, error } = useSelector((state) => state.user);

  const handleClick = async (e) => {
    // e.preventDefault();
    const res = await resetPassword(email, resetFailure);
    if (res?.data?.success === true) {
      toast.success(`🦄 ${res.data.message}`);
    }
  };

  const resetFailure = (res) => {
    toast.error(`🦄 ${res}`);
  };


  console.log("Error", error);

  return (
    <section className="login-section">
      <div className="form-wrapper">
        <h2>SET NEW PASSWORD</h2>
        <div className="form">
          <div className="form-input">
            <input
              type="text"
              placeholder="Enter Your Mail"
              name="email"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <button
            className="btn mb-4 mt-1 w-100 br-2"
            onClick={handleClick}
            disabled={isFetching}
          >
            Send mail
          </button>
        </div>
      </div>
    </section>
  );
};

export default ResetPassword;
